<template>
  <div class="system-auth-container">
    <div class="table-prefix-box">
      <div class="btn-box">
        <el-button-group class="mr-10">
          <el-button @click="showDialog" title="新增" size="mini"
                     type="primary" icon="el-icon-plus">新增
          </el-button>
          <el-button @click="clickEdit" title="编辑" size="mini"
                     type="primary" icon="el-icon-edit">编辑
          </el-button>
          <el-button @click="showAuthDialog" size="mini"
                     type="primary" icon="el-icon-s-tools">设置权限
          </el-button>
          <el-button @click="del" size="mini"
                     type="primary" icon="el-icon-delete">删除
          </el-button>
        </el-button-group>
      </div>
      <div class="search-box mt-15"></div>
    </div>

    <div class="table mt-15">
      <el-table v-loading="tableLoading" border ref="table" :data="list" highlight-current-row
                @current-change="handleCurrentChange" style="width:100%">
        <el-table-column label="ID" width="100">
          <template slot-scope="scope"><span>12</span></template>
        </el-table-column>
        <el-table-column label="名称">
          <template slot-scope="scope"><span>超级管理员</span></template>
        </el-table-column>
        <el-table-column label="唯一标识">
          <template slot-scope="scope"><span>SUPER_ADMIN</span></template>
        </el-table-column>
        <el-table-column label="字段待定">
        </el-table-column>
      </el-table>
    </div>

    <el-dialog title="添加" width="400px" :visible.sync="dialogShow">
      <div style="font-size:13px;">
        <el-input class="display-inline width100" v-model="obj.title" placeholder="请填写名称，比如 “微信接口”"
                  size="mini"></el-input>
        <el-input class="display-inline width100 mt-15" v-model="obj.url"
                  placeholder="请填写Url，格式“/api/admin_login/login”" size="mini"></el-input>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="dialogShow=false">取 消</el-button>
        <el-button size="mini" type="primary" @click="submit">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="绑定权限" width="600px" :visible.sync="authDialogShow">
      <div class="auth-box">
        <div class="item" :class="item.active?'active':''" @click="setActive(index)"
             v-for="(item,index) in [1,2,3,4,5,6,7,8,9]" :key="index">
          <span class="zsf-icon check"
                :class="item.active?'zsf-icon-yixuanze- color-409eff':'zsf-icon-weixuanze-1 color-dcdcdc'"></span>
          <span class="width-200 t-hidden"
                :class="item.pid===0?'pl-10 font-bold':'pl-30'">权限状态修改</span>
          <span class="color-999 ml-10" v-if="item.pid!==0">/api/admin_auth/edit_status</span>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="authDialogShow=false">取 消</el-button>
        <el-button size="mini" type="primary" @click="submitAuth">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
  import {tool} from "../../common/js/tool.js";
  import {Loading} from "element-ui";
  export default {
    data() {
      return {
        dialogShow: false,
        obj: {
          title: "",
          url: ""
        },
        list: [
          {sort: 1},
          {sort: 2},
          {sort: 3},
          {sort: 4},
          {sort: 6},
          {sort: 7},
          {sort: 9},
          {sort: 11},
          {sort: 13},
          {sort: 15},
          {sort: 17}
        ],
        tableLoading: false,
        authDialogShow: false
      };
    },

    computed: {},

    created() {
    },

    methods: {
      submitAuth() {
      },
      setActive(index) {
        //console.log(index);
        //console.log(this.authList[index]);
        let roleAuthList = [...this.authList];
        console.log(roleAuthList[index]["pid"]);
        //roleAuthList[index]['active'] = !roleAuthList[index]['active'];
        if (roleAuthList[index]["pid"] === 0) {
          console.log(roleAuthList[index].id);
          if (roleAuthList[index]["active"]) {
            roleAuthList[index]["active"] = false;
            for (let i = 0; i < roleAuthList.length; i++) {
              if (roleAuthList[i]["pid"] === roleAuthList[index].id) {
                roleAuthList[i].active = false;
              }
            }
          } else {
            roleAuthList[index]["active"] = true;
            for (let i = 0; i < roleAuthList.length; i++) {
              if (roleAuthList[i]["pid"] === roleAuthList[index].id) {
                roleAuthList[i].active = true;
              }
            }
          }
        } else {
          roleAuthList[index]["active"] = !roleAuthList[index]["active"];
          for (let i = 0; i < roleAuthList.length; i++) {
            if (roleAuthList[i]["id"] === roleAuthList[index].pid) {
              roleAuthList[i].active = true;
            }
          }
        }
        this.roleAuthList = roleAuthList;
        console.log(this.roleAuthList);
      },
      showDialog() {
        this.dialogShow = true;
      },
      handleCurrentChange(val) {
        this.currentRow = val;
      },
      submit() {
      },
      changeOrder(index) {
        console.log(index);
        let obj = {id: 12, sort: this.list[index].sort};
        alert(JSON.stringify(obj));
      },
      showAuthDialog() {
        if (!this.currentRow) {
          tool.message("请在表格中选择数据", "error");
          return;
        }
        this.authDialogShow = true;
      },
      clickEdit() {
        if (!this.currentRow) {
          tool.message("请在表格中选择数据", "error");
          return;
        }
        this.dialogShow = true;
      },
      del() {
        if (!this.currentRow) {
          tool.message("请在表格中选择数据", "error");
        } else {
          this.$confirm("确定要删除吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(() => {
            this.$message({
              type: "success",
              duration: 1000,
              message: "操作成功!",
              onClose: () => {
                this.getData();
              }
            });
          });
        }
      }
    },

    components: {}
  };
</script>

<style lang="less" rel="stylesheet/less">
  .system-auth-container {
    width: 100%;
    height: auto;
    display: flex;
    padding: 15px;
    flex-direction: column;
    .auth-box {
      font-size: 13px;
      height: 400px;
      overflow-y: auto;
      border-top: 1px solid #dcdcdc;
      .item {
        height: 45px;
        line-height: 45px;
        padding: 0 20px;
        border-bottom: 1px solid #dcdcdc;
        span {
          height: 45px;
          line-height: 45px;
          display: block;
          float: left;
        }
        &.active {
          background: #f9f9f9;
        }
        .check {
          display: inline-block;
          width: 30px;
        }
        .color-409eff {
          color: #409eff;
        }
        .color-dcdcdc {
          color: #dcdcdc;
        }
      }
    }
  }
</style>
